/*
 * Page Name
 */

(function ($) {

    _heightline({
        itemClsName: '.story_list_item_box ._allcnt_item ._des',
        itemPerRow: 2,
        device: 'pc'
    });

})(jQuery);